const CANHCAM_APP = {"ACTIVE_FIXED_HEADER": true,"HEADER_TRANPARENT": false,"ACTIVE_HEADER_POSITION": 1,"ACTIVE_PADDING_MAIN": true,"ACTIVE_VALIDATOR": true,"ACTIVE_SELECT": true,"ACTIVE_FIXED_FOOTER": true,"ACTIVE_LIST_TO_SELECT": true,"DISPLAY_FOOTER": 600,"ACTIVE_RESPONSIVE": true,"ACTIVE_BACKTOTOP": true,"DISPLAY_BACKTOTOP": 100,"CHANGE_GRID": 991,"CHANGE_GRID_SM": 767,"DEV_MODE": false,"DEV_MODE_GIRD_FULL": false}
function backToTop() {
    if ($('#back-to-top').length) {
        var backToTop = function() {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > CANHCAM_APP.DISPLAY_BACKTOTOP) {
                $('#back-to-top').addClass('show');
            } else {
                $('#back-to-top').removeClass('show');
            }
        };
        backToTop();
        $(window).on('scroll', function() {
            backToTop();
        });
        $('#back-to-top').on('click', function(e) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: 0
            }, 700);
        });
    }
}

$(document).ready(function() {
    if (CANHCAM_APP.ACTIVE_BACKTOTOP) {
        backToTop()
    }
});
function CanhCamResponsive() {
	// Set BG Mask
	$('[bg-mask]').each(function () {
		var bgimg = $(this).attr('bg-mask');
		$(this).css({
			"mask-image": "url(" + bgimg + ")",
			"mask-position": "center center",
			"mask-repeat": "no-repeat",
			"-webkit-mask-image": "url(" + bgimg + ")",
			"-webkit-mask-position": "center center",
			"-webkit-mask-repeat": "no-repeat"
		});
	})
	// Set BG Resposive
	$('[bg-img]').each(function () {
		var bgimg = $(this).attr('bg-img');
		var pos = $(this).attr('bg-pos');
		var size = $(this).attr('bg-size');
		if (pos && pos.length > 0) {
			$(this).css({
				"background-position": pos
			});
		} else {
			$(this).css({
				"background-position": "center center"
			});
		}
		if (size && size.length > 0) {
			$(this).css({
				"background-size": size
			});
		} else {
			$(this).css({
				"background-size": "cover"
			});
		}
		$(this).css({
			"background-image": "url(" + bgimg + ")"
		});
	});

	$('[bg-img-responsive]').each(function () {
		var bgimg = $(this).attr('bg-img-responsive');
		var bgimgsm = $(this).attr('bg-img-responsive-sm');
		var bgimgxs = $(this).attr('bg-img-responsive-xs');
		if ($(window).width() >= CANHCAM_APP.CHANGE_GRID) {
			$(this).css({
				"background-image": "url(" + bgimg + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		} else if ($(window).width() < CANHCAM_APP.CHANGE_GRID && $(window).width() > CANHCAM_APP.CHANGE_GRID_SM) {
			$(this).css({
				"background-image": "url(" + bgimgsm + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		} else {
			$(this).css({
				"background-image": "url(" + bgimgxs + ")",
				"background-position": "center center",
				"background-size": "cover"
			});
		}
	});

	$('[img-src-responsive]').each(function () {
		var bgimg2 = $(this).attr('img-src-responsive');
		var bgimg2sm = $(this).attr('img-src-responsive-sm');
		var bgimg2xs = $(this).attr('img-src-responsive-xs');
		if ($(window).width() >= CANHCAM_APP.CHANGE_GRID) {
			$(this).attr("src", "" + bgimg2 + "");
		} else if ($(window).width() < CANHCAM_APP.CHANGE_GRID && $(window).width() > CANHCAM_APP.CHANGE_GRID_SM) {
			$(this).attr("src", "" + bgimg2sm + "");
		} else {
			$(this).attr("src", "" + bgimg2xs + "");
		}
	});

};

$(function () {
	if (CANHCAM_APP.ACTIVE_RESPONSIVE) {
		CanhCamResponsive();
	}
})

$(window).resize(function () {
	if (CANHCAM_APP.ACTIVE_RESPONSIVE) {
		CanhCamResponsive();
	}
})

$(function() {
    $('[data-toggle="tooltip"]').tooltip()
    $('[data-toggle="popover"]').popover({
        trigger: 'focus'
    })
})
// Thêm [dropdown-type="hover"] vào thẻ a để bật tính năng hover open dropdown 
if ($(window).width() > CANHCAM_APP.CHANGE_GRID) {
	$('.dropdown').on('mouseenter mouseleave', function () {
		var ___d = $(this).find('[dropdown-type="hover"]').parents('.dropdown')
		if (___d && ___d.length > 0) {
			$(this).find('[dropdown-type="hover"]').removeAttr('data-toggle')
			setTimeout(function () {
				___d[___d.is(':hover') ? 'addClass' : 'removeClass']('show');
				___d.is(':hover') ? ___d.find('.dropdown-menu').show() : ___d.find('.dropdown-menu').hide()
			}, 10);
		}
	})
} else {
	$('.dropdown').each(function () {
		$(this).addClass('show')
		$(this).find('.dropdown-menu').show()
	})
}


$(document).ready(function () {
	checkDev()
});

$(window).resize(function () {
	checkDev()
})

function checkDev() {
	if ($('#devtools').length) {
		if ($(window).width() < 576) {
			$('.canhcam-develop #devtools .header-devtools h3').html('Dev - XS')
		} else if ($(window).width() >= 576 && $(window).width() < 768) {
			$('.canhcam-develop #devtools .header-devtools h3').html('Dev - SM')
		} else if ($(window).width() >= 768 && $(window).width() < 992) {
			$('.canhcam-develop #devtools .header-devtools h3').html('Dev - MD')
		} else if ($(window).width() >= 992 && $(window).width() < 1200) {
			$('.canhcam-develop #devtools .header-devtools h3').html('Dev - LG')
		} else {
			$('.canhcam-develop #devtools .header-devtools h3').html('Dev - XL')
		}
	}
}

(function ($) {
	$.fn.drags = function (opt) {

		opt = $.extend({ handle: "", cursor: "move" }, opt);

		if (opt.handle === "") {
			var $el = this;
		} else {
			var $el = this.find(opt.handle);
		}

		return $el.find('.header-devtools').css('cursor', opt.cursor).on("mousedown", function (e) {
			// getSizeDevTo()
			if (opt.handle === "") {
				var $drag = $(this).parent().addClass('draggable');
			} else {
				var $drag = $(this).parent().addClass('active-handle').parent().addClass('draggable');
			}
			var z_idx = $drag.css('z-index'),
				drg_h = $drag.outerHeight(),
				drg_w = $drag.outerWidth(),
				pos_y = $drag.offset().top + drg_h - e.pageY,
				pos_x = $drag.offset().left + drg_w - e.pageX;
			$drag.css('z-index', 99999).parents().on("mousemove", function (e) {
				getSizeDevTo()
				$('.draggable').offset({
					top: e.pageY + pos_y - drg_h,
					left: e.pageX + pos_x - drg_w
				}).on("mouseup", function () {
					// getSizeDevTo()
					$(this).removeClass('draggable').css('z-index', z_idx);
				});
				$('#devtools .inline').offset({
					top: e.pageY + pos_y - drg_h
				})
				$('#devtools .online').offset({
					left: e.pageX + pos_x - drg_w
				})
			});
			e.preventDefault(); // disable selection
		}).on("mouseup", function () {
			// getSizeDevTo()
			if (opt.handle === "") {
				$(this).removeClass('draggable');
			} else {
				$(this).removeClass('active-handle').parent().removeClass('draggable');
			}
		});

	}
})(jQuery);

if (CANHCAM_APP.DEV_MODE) {

	$('body').append('<div id="devtools"> <div class="online"></div><div class="inline"></div><div class="header-devtools"> <h3>Dev - XL</h3> </div><div class="body-devtools"> <button class="btn btn-block btn-secondary btn-sm" type="button">Toogle Grid</button> </div></div>')

	$('#devtools').drags();
	createDevTo()

	$(document).ready(function () {
		if ($('.canhcam-develop #devtools').length) {
			var devtls = $('.canhcam-develop #devtools').find('.body-devtools button')
			devtls.click(function () {
				if ($(this).attr('data-click-state') == 1) {
					$(this).attr('data-click-state', 0)
					$('body').toggleClass('active')
					$('body').find('.devtool-gird').remove()
				} else {
					$(this).attr('data-click-state', 1)
					$('body').toggleClass('active')
					if (CANHCAM_APP.DEV_MODE_GIRD_FULL) {
						$('body').append('<div class="devtool-gird"><div class="container-fluid d-flex"><div class="row d-flex align-items-stretch bd-highlight"><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div></div></div></div>')
					} else {
						$('body').append('<div class="devtool-gird"><div class="container d-flex"><div class="row d-flex align-items-stretch bd-highlight"><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div><div class="col d-flex align-items-stretch"><div class="item"></div></div></div></div></div>')
					}
				}
			});
		}
	});

}

function getSizeDevTo() {
	$('#devtools .body-devtools .size .width').html('W: ' + $(window).width() + '')
	$('#devtools .body-devtools .size .height').html('H: ' + $(window).height() + '')
	$('#devtools .body-devtools .size .top').html('T: ' + $('#devtools').offset().top + '')
	$('#devtools .body-devtools .size .left').html('L: ' + $('#devtools').offset().left + '')
}

$(window).resize(function () {
	if ($('#devtools').length) {
		getSizeDevTo()
	}
});

function createDevTo() {
	$('#devtools .body-devtools').append('<div class="size"><div class="width">W: ' + $(window).width() + '</div><div class="height">H: ' + $(window).height() + '</div><div class="top">T: ' + $('#devtools').offset().top + '</div><div class="left">L: ' + $('#devtools').offset().left + '</div></div>')
}

function countUpCanhCam() {

	$('[data-count]').each(function () {
		var elm = $(this).offset().top
		var docH = $(window).height()
		var docS = $(window).scrollTop()
		var padingTop = 0
		if ($(this).attr('data-top') && $(this).attr('data-top').length){
			padingTop = parseInt($(this).attr('data-top'));
		}
		var result = (elm + padingTop) - (docH + docS)
		var run = false

		if (result <= 0 && !run) {
			var $this = $(this),
				countTo = $this.attr('data-count'),
				durationTo = parseInt($this.attr('data-duration'));
			$({ countNum: $this.text() }).animate({
				countNum: countTo
			}, {
					duration: durationTo,
					easing: 'linear',
					step: function () {
						$this.text(Math.floor(this.countNum));
					},
					complete: function () {
						$this.text(this.countNum);
						run = true
					}
				});
		}

	});
}

$(document).ready(function () {
	countUpCanhCam()

});

$(window).scroll(function () {
	countUpCanhCam()

});

$(window).resize(function () {
	countUpCanhCam()
})

function CanhCamChangeDataHoverClick() {
	$('[data-change]').each(function () {
		var newSrc = $(this).attr('data-new')
		var oldSrc = $(this).attr('data-old')
		var typeChange = $(this).attr('data-change')
		if (typeChange && typeChange.length > 0) {
			if (typeChange === 'src') {
				$(this).hover(function () {
					$(this).attr(typeChange, newSrc)
				}, function () {
					$(this).attr(typeChange, oldSrc)
				});
			} else if (typeChange === 'background' || typeChange === 'background-image') {
				$(this).hover(function () {
					$(this).css(typeChange, "url(" + newSrc + ")")
				}, function () {
					$(this).css(typeChange, "url(" + oldSrc + ")")
				});
			} else if (typeChange === 'class') {
				$(this).hover(function () {
					$(this).removeClass(oldSrc).addClass(newSrc)
				}, function () {
					$(this).removeClass(newSrc).addClass(oldSrc)
				});
			}
		}
	});
};

$(function () {
	CanhCamChangeDataHoverClick();
})



function setFooter() {
    var bodyHeight = $("body").outerHeight(),
        headerHeight = $("header").outerHeight(),
        footerHeight = $("footer").outerHeight(),
        mainHeight = $("main").outerHeight(),
        curentHeight = mainHeight + headerHeight + footerHeight,
        curentfixedHeight = mainHeight + footerHeight,
        newHeight = bodyHeight - (headerHeight + footerHeight),
        newfixedHeight = bodyHeight - footerHeight;
    if ($(window).width() > CANHCAM_APP.DISPLAY_FOOTER) {
        if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
            $("main").css('min-height', newfixedHeight + 'px')
        } else {
            if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
                $("main").css('min-height', newHeight + 'px')
            } else {
                $("main").css('min-height', newfixedHeight + 'px')
            }
        }
    } else {
        $("main").css('min-height', 'initial')
    }
}

$(document).ready(function() {
    if (CANHCAM_APP.ACTIVE_FIXED_FOOTER) {
        setFooter()
    }
});

$(window).resize(function() {
    if (CANHCAM_APP.ACTIVE_FIXED_FOOTER) {
        setFooter()
    }
})
function setHeader(elm) {
	if (elm >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
		$("header").addClass('active');
	} else {
		$("header").removeClass('active');
	}
}

$(document).ready(function () {
	if (CANHCAM_APP.ACTIVE_FIXED_HEADER) {
		$("header").addClass('fixedheader');
		if ($(window).scrollTop() >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
			setHeader($(window).scrollTop());
		}
	} else {
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
			$("header").addClass('fixedheader');
		} else {
			$("header").removeClass('fixedheader');
		}
	}
	if ($("header").hasClass("fixedheader")) {
		$("main").addClass('main-fixedheader');
	}
});

// Fixed Header
$(window).scroll(function () {
	setHeader($(document).scrollTop());
});
// Fixed Header
$(window).resize(function () {
	if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
			$("header").addClass('fixedheader');
		} else {
			$("header").removeClass('fixedheader');
		}
	}
});


function setMain() {
    var
		headerHeight = $("header").outerHeight();
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID) {
				$("main").css('padding-top', headerHeight + 'px')
		} else {
			if (!CANHCAM_APP.ACTIVE_PADDING_MAIN) {
				$("main").css('padding-top', '0px')
			} else {
				if (!CANHCAM_APP.ACTIVE_FIXED_HEADER) {
					$("main").css('padding-top', 'initial')
				} else {
					$("main").css('padding-top', headerHeight + 'px')
				}
			}
		}
}

$(document).ready(function() {
    setMain()
});

$(window).resize(function() {
    setMain()
})

function setHeaderTranparent(elm) {
	if (elm >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
		$("header").removeClass('has-tranparent');
	} else {
		$("header").addClass('has-tranparent');
	}
}

$(document).ready(function () {
	if (CANHCAM_APP.HEADER_TRANPARENT) {
		$("header").addClass('has-tranparent');
		if ($(window).scrollTop() >= CANHCAM_APP.ACTIVE_HEADER_POSITION) {
			setHeaderTranparent($(window).scrollTop());
		}
	}

});

// Tranparent Header
$(window).scroll(function () {
	if (CANHCAM_APP.HEADER_TRANPARENT) {
		setHeaderTranparent($(document).scrollTop());
	}
});


function canhcamID(e) {
	var text = "";
	var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
	for (var i = 0; i < e; i++)
		text += possible.charAt(Math.floor(Math.random() * possible.length));
	return text;
}

function b64EncodeUnicode(str) {
	return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
		function toSolidBytes(match, p1) {
			return String.fromCharCode('0x' + p1);
		}));
}

function b64DecodeUnicode(str) {
	return decodeURIComponent(atob(str).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
}

// Copyright 2014-2017 The Bootstrap Authors
// Copyright 2014-2017 Twitter, Inc.
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style')
    msViewportStyle.appendChild(
        document.createTextNode(
            '@-ms-viewport{width:auto!important}'
        )
    )
    document.head.appendChild(msViewportStyle)
}

$(function() {
    var nua = navigator.userAgent
    var isAndroid = (nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1 && nua.indexOf('Chrome') === -1)
    if (isAndroid) {
        $('select.form-control').removeClass('form-control').css('width', '100%')
    }
})
function listToSelect() {
	$('[data-select]').each(function () {
		var list = $(this), select = $(document.createElement('select')).insertBefore($(this).hide());
		select.addClass('custom-select').attr('data-select-show', '');
		$('>li a', this).each(function () {
			var option = $(document.createElement('option'))
				.appendTo(select)
				.val(this.href)
				.html($(this).html())
		});
		list.hide().removeAttr('data-select').attr('data-select-changed', '');
		select.on('change', function () {
			var url = $(this).val();
			if (url) {
				window.location = url;
			}
			return false;
		});
	});
}

function selectChangeToList() {
	if (CANHCAM_APP.ACTIVE_LIST_TO_SELECT) {
		if ($(window).width() > CANHCAM_APP.CHANGE_GRID_SM) {
			$('[data-select-changed]').each(function () {
				$(this).show().removeAttr('data-select-changed').attr('data-select', '');
			})
			$('[data-select-show]').remove()
		} else {
			listToSelect()
		}
	}
}

$(document).ready(function () {
	if (CANHCAM_APP.ACTIVE_LIST_TO_SELECT) {
		if ($(window).width() <= CANHCAM_APP.CHANGE_GRID_SM) {
			listToSelect()
		}
	}
});

$(window).resize(function () {
	if (CANHCAM_APP.ACTIVE_LIST_TO_SELECT) {
		selectChangeToList()
	}
});


console.log('%cCANHCAM', 'font-size:100px;color:#ff451a;text-shadow:0 1px 0 #f73936,0 2px 0 #f73936 ,0 3px 0 #f73936 ,0 4px 0 #f73936 ,0 5px 0 #f73936 ,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);')
console.log('%c CANHCAM ' + '%c - The best Web Solutions Provider', 'border-radius: 2px; padding: 3px; background: #ff451a; color: #FFF', 'color: #ff451a');
console.warn("CANHCAM warning: This is a browser feature intended for developers. If someone told you to copy and paste something here to enable a CANHCAM feature or 'hack' someone's account, it is a scam and will give them access to your CANHCAM account.");
document.onkeyup = function (a) { if ((a = a || window.event).altKey && a.ctrlKey && a.shiftKey && 13 == a.which) return $("body"), alert(b64DecodeUnicode("QkFPIE5HVVlFTiAtIDA5Njk2ODk4OTMKRW1haWw6IGJhb25ndXllbnlhbUBnbWFpbC5jb20KV2ViOiBiYW9uZ3V5ZW55YW0uZ2l0aHViLmlv")), !1 };

!function(e,t){"function"==typeof define&&define.amd?define([],function(){return t(e)}):"object"==typeof exports?module.exports=t(e):e.MappingListener=t(e)}("undefined"!=typeof global?global:"undefined"!=typeof window?window:this,function(e){"use strict";var t;t={breakpoint:992};var n=function(){var e={},t=!1,o=0;"[object Boolean]"===Object.prototype.toString.call(arguments[0])&&(t=arguments[0],o++);for(var i=function(o){for(var i in o)o.hasOwnProperty(i)&&(t&&"[object Object]"===Object.prototype.toString.call(o[i])?e[i]=n(e[i],o[i]):e[i]=o[i])};o<arguments.length;o++){i(arguments[o])}return e};return function(o){var i,r={};return r.switch=function(){e.matchMedia(`(min-width: ${i.breakpoint}px)`).matches?Mapping.mapElements.from(i.selector).to(i.desktopWrapper).use(i.desktopMethod):Mapping.mapElements.from(i.selector).to(i.mobileWrapper).use(i.mobileMethod)},r.watch=function(){this.switch(),e.matchMedia(`(min-width: ${i.breakpoint}px)`).addListener(r.switch)},r.init=function(e){i=function(e){switch(e.breakpoint){case"sm":e.breakpoint=576;break;case"md":e.breakpoint=768;break;case"lg":e.breakpoint=992;break;case"xl":e.breakpoint=1200}return e}(i=n(t,e||{}))},r.init(o),r}});

"use strict";!function(t,e){"function"==typeof define&&define.amd?define([],function(){return e(t)}):"object"==typeof exports?module.exports=e(t):t.Mapping=e(t)}("undefined"!=typeof global?global:"undefined"!=typeof window?window:this,function(t){var e={};return e.mapElements={html:"",department:"",destination:"",from:function(t){try{return this.department=document.querySelector(t),this.html=function(t){if(document.body.contains(t))return t.parentElement.removeChild(t);throw"Element is not found"}(this.department),this}catch(t){}},to:function(t){try{return this.destination=document.querySelector(t),this}catch(t){}},use:function(t){try{switch(t){case"appendTo":this.destination.append(this.html);break;case"prependTo":this.destination.prepend(this.html);break;case"insertBefore":this.destination.parentElement.insertBefore(this.html,this.destination);break;case"insertAfter":e=this.html,(n=this.destination).parentNode.insertBefore(e,n.nextSibling)}}catch(t){}var e,n}},e});

// Ripple
function ccCreateRipple() {
	$('[ripple]').on('click', function (e) {
		var rippleDiv = $('<div class="ripple" />'),
			rippleOffset = $(this).offset(),
			rippleY = e.pageY - rippleOffset.top,
			rippleX = e.pageX - rippleOffset.left,
			ripple = $('.ripple');

		rippleDiv.css({
			top: rippleY - (ripple.height() / 2),
			left: rippleX - (ripple.width() / 2),
			background: $(this).attr("ripple-color")
		}).appendTo($(this));
		window.setTimeout(function () {
			rippleDiv.remove();
		}, 1500);
	});
}

$(document).ready(function () {
	ccCreateRipple()
});

$(document).ready(function () {
	if (CANHCAM_APP.ACTIVE_SELECT) {
		$(".select2").select2({
			placeholder: "Chọn một"
		});

		$('.select2').on("select2:select", function (e) {
			var valSelect = $(e.currentTarget).val()
		});
		$('.select2').on("select2:unselect", function (e) {
			var valUnselect = $(e.currentTarget).val()
		});
	}
});

function selectResset(e) {
	$(e).val(null).trigger("change", 0);
}

function canhCamStickyComtent() {

	$('[data-fix]').each(function () {
		$(this).css({
			"z-index": '500'
		})
		if ($(this).attr('data-top') && $(this).attr('data-top').length) {
			$(this).css({
				"top": $(this).attr('data-top')
			})
		}
		if ($(this).attr('data-left') && $(this).attr('data-left').length) {
			$(this).css({
				"left": $(this).attr('data-left')
			})
		}
		if ($(this).attr('data-bottom') && $(this).attr('data-bottom').length) {
			$(this).css({
				"bottom": $(this).attr('data-bottom')
			})
		}
		if ($(this).attr('data-right') && $(this).attr('data-right').length) {
			$(this).css({
				"right": $(this).attr('data-right')
			})
		}

		var toFix = 0
		var typeFix = 'fixed'
		var changeFix = 'static'

		if ($(this).attr('data-fix') && $(this).attr('data-fix').length) {
			toFix = parseInt($(this).attr('data-fix'))
		}
		if ($(this).attr('data-fix-type') && $(this).attr('data-fix-type').length) {
			typeFix = $(this).attr('data-fix-type')
		}
		if ($(this).attr('data-fix-change') && $(this).attr('data-fix-change').length) {
			changeFix = $(this).attr('data-fix-change')
		}

		$(this).css({
			"position": typeFix
		})

		var scrollTop = $(window).scrollTop();
		var elementOffset = $(this).offset().top;
		var currentElementOffset = (elementOffset - scrollTop);
		if (currentElementOffset <= toFix) {
			$(this).css({
				"position": changeFix,
				"top": toFix + 'px'
			})
		}

	});
}


$(document).ready(function () {
	canhCamStickyComtent()
});

$(window).scroll(function () {
	canhCamStickyComtent()
});

$(window).resize(function () {
	canhCamStickyComtent()
})

$(document).ready(function () {
	if (CANHCAM_APP.ACTIVE_VALIDATOR) {
		$('[data-toggle="validator"]').validator({
			feedback: {
				success: 'fa fa-check',
				error: 'fa fa-close'
			}
		}).on('submit', function (e) {
			if (e.isDefaultPrevented()) {
				$('[data-toggle="validator"]').find('select').parent('.form-group').addClass('has-danger')
			}
		})
		if ($('[data-toggle="validator"]').find('select').hasClass('has-success')) {
			this.removeClass('has-danger')
		}
	}
});

function CCHeader12() {
	$('.canhcam-header-12 #demoResAllInOneMenu').kResponsiveMenu({
		animationSpeed: 'fast', // slow, fast, 200
		resizeWidth: 'lg', // 'xs', 'sm', 'md', 'lg', 'xl', 480,
		menuType: 'horizontal', // horizontal, vertical
		menuPush: 'right', // right, left
		menuPushPosition: 'fixed', // absolute
		menuPushWidth: '300px', // px, %, rem
		menuBackDrop: true, // px, %, rem
	})
};




function tab_fixing() {
if (window.location.href.search('#tab-tl-1') >= 1) {
	$('#myTab li:first-child a').trigger('click')
	$('.Module-159').addClass('tab-pane fade active show')
} else {
	$('#myTab li:nth-child(2) a').trigger('click')
	$('.Module-160').addClass('tab-pane fade active show')
}
$('.canhcam-header-12  .mainnav  .wrapper .nav .nav-item:nth-child(5) .sub-link a:first-child').on('click', function(){
	$('#myTab li:first-child a').trigger('click')

})
$('.canhcam-header-12  .mainnav  .wrapper .nav .nav-item:nth-child(5) .sub-link a:nth-child(2)').on('click', function(){
	$('#myTab li:nth-child(2) a').trigger('click')

})


}
$(document).ready(function () {
});



$(document).ready(function () {
	$('.Module-159').addClass('tab-pane fade ')
	$('.Module-159').attr('id','tab-1');
	$('.Module-160').addClass('tab-pane fade ')
	$('.Module-160').attr('id','tab-2');
	tab_fixing();
	CCHeader12();
	// setHeightheader()
	search()
});
// Fixed Header
$(window).scroll(function () {
	// $('.canhcam-header-12 .register ').height(0)
	// setHeightheader()
});

$(window).resize(function () {
	// setHeightheader()
})

function search() {
	$('.search').click(function () {
		$('.searchbox').toggleClass('active')
	})
}

function setHeightheader() {
	var maxHeight = 0;

	$('.canhcam-header-12 .k-responsive-menu').each(function () {
		var thisH = $(this).height();
		if (thisH > maxHeight) {
			maxHeight = thisH;
		}
	});
	$('.canhcam-header-12 .register ').height(maxHeight)
}

$(document).ready(function () {

});

$(window).resize(function () {})
$(function () {
	if ($('.canhcam-home-1 .list-items').length) {
		$(".canhcam-home-1 .list-items").not('.slick-initialized').slick({
			autoplay: true,
			dots: false,
			infinite: true,
			speed: 300,
			pauseOnHover: false,
			pauseOnFocus: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			customPaging: function(slider, i) {
			    var thumb = $(slider.$slides[i]).data('thumb');
			    return '<a><p> ' + thumb + '</p></a>';
			},
		});
	}

});

$(document).ready(function () {
	$('.canhcam-home-2 .dropdown-menu').css('display', '')
});

$(function () {
	if ($('.canhcam-home-2 .list-items').length) {
		$(".canhcam-home-2 .list-items").not('.slick-initialized').slick({
			autoplay: true,
			// slickPlay: true,
			// slickPause: true,
			autoplaySpeed: 1600,
			dots: true,
			infinite: false,
			speed: 300,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			// customPaging: function(slider, i) {
			//     var thumb = $(slider.$slides[i]).data('thumb');
			//     return '<a><p> ' + thumb + '</p></a>';
			// },
		});
	}

});

$(function () {
	$(".canhcam-home-2 .pause").click(function(){
		$(".canhcam-home-2 .list-items").slick('slickPause');
		$(this).hide()
		$(".canhcam-home-2 .play").show()

	})
	$(".canhcam-home-2 .play").click(function(){
		$(".canhcam-home-2 .list-items").slick('slickPlay');
		$(this).hide()
		$(".canhcam-home-2 .pause").show()

	})
})

$(document).ready(function () {
	AOS.init();
});

$(function () {
	if ($('.canhcam-home-2 .list-items').length) {
		$(".canhcam-home-2 .list-items").not('.slick-initialized').slick({
			autoplay: true,
			// slickPlay: true,
			// slickPause: true,
			autoplaySpeed: 1600,
			dots: true,
			infinite: false,
			speed: 300,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			// customPaging: function(slider, i) {
			//     var thumb = $(slider.$slides[i]).data('thumb');
			//     return '<a><p> ' + thumb + '</p></a>';
			// },
		});
	}

});

$(function () {
	$(".canhcam-home-2 .pause").click(function(){
		$(".canhcam-home-2 .list-items").slick('slickPause');
		$(this).hide()
		$(".canhcam-home-2 .play").show()

	})
	$(".canhcam-home-2 .play").click(function(){
		$(".canhcam-home-2 .list-items").slick('slickPlay');
		$(this).hide()
		$(".canhcam-home-2 .pause").show()

	})
})




function changeIMGtoDiv1(){
	$('.canhcam-news-details-1 .othernews .item figure').each(function () {
		var tmp = $(this).find('img').attr('src')
		$(this).append('<div class="thumb"></div>')
		$(this).find('.thumb').css({
			"background-image": "url(" + tmp + ")",
			"background-position": "center center",
			"background-size": "cover"
		})
	})
}
function changeIMGtoDiv1_subject(){
	$('.canhcam-subject-details-1 .othernews .item figure').each(function () {
		var tmp = $(this).find('img').attr('src')
		$(this).append('<div class="thumb"></div>')
		$(this).find('.thumb').css({
			"background-image": "url(" + tmp + ")",
			"background-position": "center center",
			"background-size": "cover"
		})
	})
}


$(document).ready(function() {
	changeIMGtoDiv1()
	changeIMGtoDiv1_subject()
});

$(window).resize(function () {
	changeIMGtoDiv1_subject()
	changeIMGtoDiv1()
})


function createNewsSocial1() {
	var newsFullPath = document.URL
	var newsFullPathEncode = encodeURIComponent(document.URL)
	$('.fb-share-button').attr('data-href', newsFullPath)
	$('.fb-share-button .fb-xfbml-parse-ignore').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + newsFullPathEncode + '&src=sdkpreparse')
	$('.twitter-share-button').attr('data-url', newsFullPath)
}


$(document).ready(function() {
	changeNewsDetail1()
	createNewsSocial1()

});




// if ( $('.remodal .wrap-form .form-group.qdropdown:nth-last-child(3) option:selected').val() < 20 ) {
// 	$(this).hide()
// }

// $(document).ready(function() {
// 	$('.remodal .wrap-form select').addClass('cus_option')
//     $('.remodal .wrap-form select .cus_option').select2();
//     // $('#option2').select2();
// });

$(document).ready(function () {
	$('.vi-vn .remodal-wrapper .remodal .wrap-form > div .form-group:nth-last-child(5) input ').attr("placeholder", "Vd: Nguyễn Văn A")
	$('.vi-vn .remodal-wrapper .remodal .wrap-form > div .form-group:nth-last-child(4) input ').attr("placeholder", "Vd: nguyenvana@gmail.com" )
	$('.vi-vn .remodal-wrapper .remodal .wrap-form > div .form-group:nth-last-child(3) input ').attr("placeholder", "Vd: 0813456789")
	// document.getElementById("ctl00_mdl234_ctl00_ctle7bd2fef77cc4db48fec3efca030f0d6_txte7bd2fef77cc4db48fec3efca030f0d6").placeholder = "Vd: Nguyễn Văn A";
	// $('').
	// document.getElementById("ctl00_mdl234_ctl00_ctlbde18f2a744e4a61ad564cc94a75def2_txtbde18f2a744e4a61ad564cc94a75def2").placeholder = "Vd: nguyenvana@gmail.com";
	// document.getElementById("ctl00_mdl234_ctl00_ctlb9a6f7c2f29f494ead87ce708fa6a452_txtb9a6f7c2f29f494ead87ce708fa6a452").placeholder = "Vd: 0813456789";
	setTimeout(function(){ $("body .remodal-wrapper").appendTo("#aspnetForm"); }, 500);
});


function CCFooter6() {

};

$(function() {
    CCFooter6();
})

$(window).resize(function() {})


// function setWidthli_intro() {
//     var maxWidth = 0;

//     $('.canhcam-intro-1 .wrapper ul li ').each(function() {
//         var thisH = $(this).width();
//         if (thisH > maxWidth) { maxWidth = thisH; }
//     });
//     $('.canhcam-intro-1 .wrapper ul li ').width(maxWidth)
// }
// $(function() {
//     setWidthli_intro()
// })
// function scrollMenu_intro() {

// 	$('.canhcam-intro-2 .wrapper .list-inline .list-inline-item').on('click', function () {
// 		var idBlock = $(this).find('.li-link').attr('href');
// 		var pos = $(idBlock).offset().top;
// 		var scrollTo = pos - $('.canhcam-header-12').outerHeight() 
// 		$('html, body').animate({
// 			scrollTop: scrollTo
// 		}, 500);
// 	});
// }

// $(document).ready(function () {
// 	scrollMenu_intro()
// })


$(function () {
	if ($('.canhcam-intro-4 .list-items').length) {
		$(".canhcam-intro-4 .list-items").not('.slick-initialized').slick({
			autoplay: true,
			// slickPlay: true,
			// slickPause: true,
			autoplaySpeed: 4000,
			dots: true,
			infinite: true,
			speed: 300,
			arrows: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			// customPaging: function(slider, i) {
			//     var thumb = $(slider.$slides[i]).data('thumb');
			//     return '<a><p> ' + thumb + '</p></a>';
			// },
		});
	}

});




function setWidthli_intro() {
    var maxWidth = 0;

    $('.canhcam-intro-nav .wrapper ul li ').each(function() {
        var thisH = $(this).width();
        if (thisH > maxWidth) { maxWidth = thisH; }
    });
    $('.canhcam-intro-nav .wrapper ul li ').width(maxWidth)
}
$(function() {
    // setWidthli_intro()
})
function scrollMenu_intro() {

	$('.canhcam-intro-nav .wrapper .list-inline .list-inline-item').on('click', function () {
		var idBlock = $(this).find('.li-link').attr('href');
		var pos = $(idBlock).offset().top;
		var scrollTo = pos - $('.canhcam-header-12').outerHeight() + 10
		$('.canhcam-intro-nav .wrapper .list-inline .list-inline-item .li-link').removeClass('active')
		$(this).find('.li-link').toggleClass('active')
		$('html, body').animate({
			scrollTop: scrollTo
		}, 500);
	});
}

$(document).ready(function () {
	scrollMenu_intro()
})


// function scrollAddClass_intro() {
//     var e = $(document).scrollTop();
//     $('.canhcam-intro-nav .wrapper .list-inline .list-inline-item').each(function() {
//         var idBlock = $(this).find('.li-link').attr('href');
//         var pos = $(idBlock).offset().top - $('.canhcam-header-12').outerHeight() - 350;
//         if (e > pos) {
//             $('.canhcam-intro-nav .wrapper .list-inline .list-inline-item').removeClass('active')
//             $(this).addClass('active');
//         }
//     })
// }
// $(document).on('scroll', function() {

//     scrollAddClass_intro();
// })


$(document).ready(function() {
	$('.canhcam-news-4 .news-list #list').click(function (event) {
		event.preventDefault();
		$(this).addClass('active')
		$('.canhcam-news-4 .news-list #grid').removeClass('active')
		$('.canhcam-news-4 #products').addClass('list-group-wrapper').removeClass('grid-group-wrapper');
	});
	$('.canhcam-news-4 .news-list #grid').click(function (event) {
		event.preventDefault();
		$(this).addClass('active')
		$('.canhcam-news-4 .news-list #list').removeClass('active')
		$('.canhcam-news-4 #products').removeClass('list-group-wrapper').addClass('grid-group-wrapper');
	});
});

$(window).resize(function () {
})

function changeNewsDetail1() {
	$(".canhcam-news-details-1 .news-read").lightGallery({
		thumbnail: true,
		animateThumb: false,
		showThumbByDefault: false,
		selector: '.item-news-read'
	});
}
function changeNewsDetail1_subject() {
	$(".canhcam-subject-details-1 .news-read").lightGallery({
		thumbnail: true,
		animateThumb: false,
		showThumbByDefault: false,
		selector: '.item-news-read'
	});
}




$(document).ready(function() {
	changeNewsDetail1()
	changeNewsDetail1_subject()
});




function ProductDetailShop1() {
	$('.canhcam-gallery-details-1 .product-details .slider-for').not('.slick-initialized').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		infinite: true,
		autoplay: false,
		asNavFor: '.slider-nav'
	});
	$('.canhcam-gallery-details-1 .product-details .slider-nav').not('.slick-initialized').slick({
		autoplay: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		asNavFor: '.slider-for',
		dots: false,
		arrows: true,
		centerMode: false,
		focusOnSelect: true,
		prevArrow: $('.top-arrow'),
		nextArrow: $('.bottom-arrow'),
		vertical: true,
		variableWidth: false,
		verticalSwiping: false,
		infinite: true,
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 6,
				vertical: false,
				verticalSwiping: false,
				variableWidth: false
			}},
			{
			breakpoint: 768,
			settings: {
				vertical: false,
				slidesToShow: 4,
				verticalSwiping: false,
				variableWidth: false
			}
			
		}]
	}).on('init', function (event, slick, direction) {
		if (!$('.canhcam-gallery-details-1 .product-details .slider-nav .top-arrow').is(':visible')) {
			$('.canhcam-gallery-details-1 .product-details .slider-control').css({
				'padding-top': '0px'
			})
		}
	}).on('afterChange', function (event, slick, currentSlide, nextSlide) {
		var getcs = slick.$slides.length - 1
		if (currentSlide == 0) {
			$('.canhcam-gallery-details-1 .product-details .top-arrow').attr('disabled', 'disabled')
		} else {
			$('.canhcam-gallery-details-1 .product-details .top-arrow').removeAttr('disabled')
		}
		if (getcs == currentSlide) {
			$('.canhcam-gallery-details-1 .product-details .bottom-arrow').attr('disabled', 'disabled')
		} else {
			$('.canhcam-gallery-details-1 .product-details .bottom-arrow').removeAttr('disabled')
		}
	});
};



function Gallerydetail() {
	$(".canhcam-gallery-details-1 .slider-for ").lightGallery({
		thumbnail: true,
		animateThumb: false,
		showThumbByDefault: false,
		selector: 'a'
	});
}




$(document).ready(function() {
	Gallerydetail()
});








$(document).ready(function () {

	ProductDetailShop1();

	$('.canhcam-gallery-details-1 #quantity input').TouchSpin({
		min: 0,
		max: 100,
		buttondown_class: "btn btn-default",
		buttonup_class: "btn btn-default"
	});

});


$(function () {

})

$(window).resize(function () {})
$(function () {
	if ($('.canhcam-gallery-details-1 .list-items').length) {
		$(".canhcam-gallery-details-1 .list-items").not('.slick-initialized').slick({
			// autoplay: true,
			// slickPlay: true,
			// slickPause: true,
			autoplaySpeed: 1600,
			dots: false,
			infinite: true,
			speed: 300,
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			// customPaging: function(slider, i) {
			//     var thumb = $(slider.$slides[i]).data('thumb');
			//     return '<a><p> ' + thumb + '</p></a>';
			// },
		});
	}
	if ($('.canhcam-gallery-details-1  .owl-carousel').length) {
		$(' .canhcam-gallery-details-1 .owl-carousel').owlCarousel({
			loop: true,
			margin: 30,
			nav: true,
			dots: false,
			navText: ["<span class='lnr lnr-chevron-left'></span>","<span class='lnr lnr-chevron-right'></span>"],
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2
				},
				992: {
					items: 3
				}
			}
		})
	}
});

// $(document).ready(function () {
// 	// $('.canhcam-rqa-1 .canhcam-kl-1 .item:first-child .name').addClass('active');
// 	$('.canhcam-collect-bvqg-1  .nav    .nav-item  .list-unstyled').hide();
// 	$('.canhcam-collect-bvqg-1  .nav    .nav-item').removeClass('active');
// 	// $('.canhcam-collect-bvqg-1 .canhcam-kl-1 .item:first-child .list-unstyled').show();
// 	$('.canhcam-collect-bvqg-1 .nav  .nav-item  .nav-link  ').on('click', (function () {
// 		if ($(this).parents('.nav-item ').find('list-unstyled').is(':hidden') === true) {
// 			// $('.canhcam-collect-bvqg-1 .nav-item').removeClass('active');
// 			// $('.canhcam-collect-bvqg-1 .nav-item list-unstyled').slideUp();
// 			$(this).parents('.nav-item').find('list-unstyled').slideDown();
// 			$(this).parents('.nav-item').addClass('active');
// 		} else {
// 			$(this).parents('.nav-item').removeClass('active');
// 			$(this).parents('.nav-item').find('list-unstyled').slideUp();
// 		}
// 	}));
// })

$(function () {
	$('.canhcam-collect-ckmm-1  .nav    .nav-item  .list-unstyled').hide();
	// $('.canhcam-collect-ckmm-1  .nav    .nav-item').removeClass('active');
	// $('.canhcam-collect-ckmm-1 .canhcam-kl-1 .item:first-child .list-unstyled').show();

	$('.canhcam-collect-ckmm-1 .nav .nav-item  ul li a.active').parents('.nav-item').addClass('active')
	$('.canhcam-collect-ckmm-1 .nav .nav-item  ul li a.active').parents('.nav-item').find('.list-unstyled').slideDown()
	
	$('.canhcam-collect-ckmm-1 .nav .nav-item  .nav-link  ').on('click', (function () {
		if ($(this).parents('.nav-item ').find('.list-unstyled').is(':hidden') === true) {
			// $('.canhcam-collect-ckmm-1 .nav-item').removeClass('active');
			// $('.canhcam-collect-ckmm-1 .nav-item .list-unstyled').slideUp();
			$(this).parents('.nav-item').find('.list-unstyled').slideDown();
			$('.canhcam-collect-ckmm-1 .nav .nav-item   ').removeClass('active')
			$(this).parents('.nav-item').addClass('active');
		} else {
			$(this).parents('.nav-item').removeClass('active');
			$(this).parents('.nav-item').find('.list-unstyled').slideUp();
			
		}
	}));
	
})
$(function () {
	$('.canhcam-collect-bvqg-1  .nav    .nav-item  .list-unstyled').hide();
	$('.canhcam-collect-bvqg-1 .nav .nav-item  ul li a.active').parents('.nav-item').addClass('active')
	$('.canhcam-collect-bvqg-1 .nav .nav-item  ul li a.active').parents('.nav-item').find('.list-unstyled').slideDown()
	// $('.canhcam-collect-bvqg-1  .nav    .nav-item').removeClass('active');
	// $('.canhcam-collect-bvqg-1 .canhcam-kl-1 .item:first-child .list-unstyled').show();
	$('.canhcam-collect-bvqg-1 .nav .nav-item  .nav-link  ').on('click', (function () {
		if ($(this).parents('.nav-item ').find('.list-unstyled').is(':hidden') === true) {
			// $('.canhcam-collect-bvqg-1 .nav-item').removeClass('active');
			// $('.canhcam-collect-bvqg-1 .nav-item .list-unstyled').slideUp();
			$(this).parents('.nav-item').find('.list-unstyled').slideDown();
			$('.canhcam-collect-bvqg-1 .nav .nav-item   ').removeClass('active')
			$(this).parents('.nav-item').addClass('active');

		} else {
			$(this).parents('.nav-item').removeClass('active');
			$(this).parents('.nav-item').find('.list-unstyled').slideUp();

		}
	}));

})


// $(document).ready(function () {

// 	/* This is basic - uses default settings */

// 	$("#image").fancybox();

// 	/* Using custom settings */

// 	// $("a#inline").fancybox({
// 	// 	'hideOnContentClick': true
// 	// });

// 	// /* Apply fancybox to multiple items */

// 	$("#image").fancybox({
// 		'transitionIn': 'elastic',
// 		'transitionOut': 'elastic',
// 		'speedIn': 600,
// 		'speedOut': 200,
// 		'overlayShow': false
// 	});

// });


$(function () {
	
})

$(document).ready(function() {
	
	$('.show-long-time .canhcam-show-detail-1 .col-md-3 .link .sub-link').hide();
	$('.show-long-time .canhcam-show-detail-1 .col-md-3 .link .sub-link a.active').parents('.link').addClass('active');
	$('.show-long-time .canhcam-show-detail-1 .col-md-3 .link .sub-link a.active').parents('.link').find('.sub-link').slideToggle();
	$('.show-long-time .canhcam-show-detail-1  .col-md-3 .link ').each(function(){

		$(this).on('click', (function(){
			if ($(this).find('.sub-link a').length){
				$(this).toggleClass('active')

			}
			$(this).find('.sub-link').slideToggle()

			$(this).siblings().find('.sub-link').slideUp()
		}))
	})

});



function changeNewsDetail1_map() {
	$(".canhcam-map-1 .news-read").lightGallery({
		thumbnail: true,
		animateThumb: false,
		showThumbByDefault: false,
		selector: '.item-news-read'
	});
}




$(document).ready(function() {
	changeNewsDetail1_map()
});


$(document).ready(function () {
		$('.canhcam-service-1 .owl-carousel').owlCarousel({
			loop: true,
			autoplay: false,
			autoplayTimeout: 4000,
			nav: true,
			items: 1,
			dots: false,
			navText: ["<span class='lnr lnr-chevron-left'></span>","<span class='lnr lnr-chevron-right'></span>"]

		})
});


function setHeightH3_tour_1() {
	var maxHeight = 0;

	$('.canhcam-tour-1 .info_wrapper').each(function () {
		var thisH = $(this).height();
		if (thisH > maxHeight) {
			maxHeight = thisH;
		}
	});
	$('.canhcam-tour-1 .info_wrapper').height(maxHeight)
}
function setHeightH3_tour_3() {
	var maxHeight = 0;

	$('.canhcam-tour-3 .wrapper_block .wrapper-contact').each(function () {
		var thisH = $(this).height();
		if (thisH > maxHeight) {
			maxHeight = thisH;
		}
	});
	$('.canhcam-tour-3 .wrapper_block .wrapper-contact').height(maxHeight)
}
$(function () {
	setHeightH3_tour_1()
	setHeightH3_tour_3()
})






$(document).ready(function() {

});

$(window).resize(function() {

})
